import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { CheckCircle, MessageCircle, Upload, ArrowRight } from 'lucide-react';

const SuccessPage = () => {
  return (
    <div className="app-content bg-[#050505] min-h-screen">
      <Navbar />
      
      <section className="py-32 min-h-screen flex items-center justify-center">
        <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
          {/* Success Icon */}
          <div className="mb-8">
            <CheckCircle className="text-green-500 mx-auto" size={80} data-testid="success-icon" />
          </div>

          {/* Title */}
          <h1 className="text-5xl md:text-6xl font-black uppercase mb-4 text-shadow-red" data-testid="success-title">
            <span className="text-red-500">PAYMENT</span> SUCCESSFUL
          </h1>
          <p className="text-xl text-gray-400 mb-12 font-['Rajdhani']">
            Your order has been confirmed! Here's what to do next...
          </p>

          {/* Instructions */}
          <div className="bg-[#0A0A0A] border border-red-500/30 p-8 mb-8 text-left">
            <h2 className="text-2xl font-bold uppercase mb-6 text-red-500 font-['Rajdhani']" data-testid="instructions-title">
              NEXT STEPS
            </h2>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="bg-red-600 text-white w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  1
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white mb-2 flex items-center gap-2">
                    <MessageCircle size={20} className="text-red-500" />
                    Join Our Discord Server
                  </h3>
                  <p className="text-gray-400 mb-3">
                    Click the button below to join our Discord community where you'll receive support.
                  </p>
                  <a
                    href="https://discord.gg/afkrev"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="discord-button"
                    className="inline-flex items-center gap-2 bg-[#5865F2] hover:bg-[#4752C4] text-white font-bold py-3 px-6 uppercase tracking-wider transition-all"
                  >
                    JOIN DISCORD SERVER
                    <ArrowRight size={20} />
                  </a>
                </div>
              </div>

              <div className="border-t border-white/10 pt-6">
                <div className="flex items-start gap-4">
                  <div className="bg-red-600 text-white w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                    2
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-white mb-2 flex items-center gap-2">
                      <Upload size={20} className="text-red-500" />
                      Open a Ticket & Upload Payment Screenshot
                    </h3>
                    <p className="text-gray-400 mb-3">
                      Once you're in Discord, open a support ticket in the designated channel.
                    </p>
                    <div className="bg-yellow-900/20 border border-yellow-500/30 p-4">
                      <p className="text-yellow-400 text-sm font-bold uppercase tracking-wider mb-2">
                        IMPORTANT:
                      </p>
                      <p className="text-gray-300 text-sm">
                        Please upload a screenshot of your Stripe payment confirmation in the ticket. This helps us process your order faster!
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border-t border-white/10 pt-6">
                <div className="flex items-start gap-4">
                  <div className="bg-red-600 text-white w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                    3
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-white mb-2">
                      Get Your Boost!
                    </h3>
                    <p className="text-gray-400">
                      Our team will reach out in your ticket to start your order. Most orders are completed within 24 hours!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/portal"
              data-testid="view-orders-button"
              className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-8 uppercase tracking-widest transition-all"
            >
              VIEW MY ORDERS
            </Link>
            <Link
              to="/"
              data-testid="back-home-button"
              className="bg-transparent border border-white/20 hover:border-red-500 text-white py-3 px-8 uppercase tracking-widest transition-all"
            >
              BACK TO HOME
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SuccessPage;